import axios from 'axios';

// Tipos para as formas de pagamento
export interface FormaPagamentoType {
  id: string;
  codigo: number;
  descricao: string;
  tipo: string;
  contaDestinoId?: string;
  contaDestinoNome?: string;
  movimentaCaixa: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  prazos: PrazoAssociadoType[];
}

export interface PrazoAssociadoType {
  id: string;
  descricao: string;
  parcela: number;
  isDeleted: boolean;
}

// DTOs
export interface CriarFormaPagamentoDto {
  descricao: string;
  tipo: number;
  contaDestinoId?: string;
  prazosIds?: string[];
  movimentaCaixa: boolean;
}

export interface AlterarFormaPagamentoDto {
  descricao: string;
  tipo: number;
  contaDestinoId?: string;
  prazosIds?: string[];
  movimentaCaixa: boolean;
}

// Tipo para as contas no contexto de formas de pagamento
export interface ContaFormaPagamentoType {
  id: string;
  nome: string;
}

// Service para comunicação com a API
export const formaPagamentoService = {
  /**
   * Obtém todas as formas de pagamento
   */
  async obterFormasPagamento(incluirInativas: boolean = false): Promise<FormaPagamentoType[]> {
    const response = await axios.get<FormaPagamentoType[]>('/api/formapagamento', {
      params: { incluirInativas }
    });
    return response.data;
  },

  /**
   * Obtém uma forma de pagamento específica
   */
  async obterFormaPagamento(id: string): Promise<FormaPagamentoType> {
    const response = await axios.get<FormaPagamentoType>(`/api/formapagamento/${id}`);
    return response.data;
  },

  /**
   * Cria uma nova forma de pagamento
   */
  async criarFormaPagamento(dto: CriarFormaPagamentoDto): Promise<void> {
    await axios.post('/api/formapagamento', dto);
  },

  /**
   * Altera uma forma de pagamento existente
   */
  async alterarFormaPagamento(id: string, dto: AlterarFormaPagamentoDto): Promise<void> {
    await axios.put(`/api/formapagamento/${id}`, { ...dto, id });
  },

  /**
   * Exclui uma forma de pagamento (soft delete)
   */
  async excluirFormaPagamento(id: string): Promise<void> {
    await axios.delete(`/api/formapagamento/${id}`);
  },

  /**
   * Reativa uma forma de pagamento
   */
  async reativarFormaPagamento(id: string): Promise<void> {
    await axios.patch(`/api/formapagamento/${id}/reativar`);
  },

  /**
   * Obtém todas as contas disponíveis para vinculação com formas de pagamento
   */
  async obterContasParaFormaPagamento(): Promise<ContaFormaPagamentoType[]> {
    const response = await axios.get<ContaFormaPagamentoType[]>('/api/formapagamento/contas');
    return response.data;
  }
}; 